import React from "react";
import Navbar from "../Components/Common/Navbar";
import ChartForm from "../Components/createChart/ChartForm";
import backgroundImg from "../Assets/Images/background.png";

const CreateChartPage = () => {
  return (
    <div className="relative min-h-screen">
      <div
        className="absolute inset-0 bg-cover bg-center opacity-40"
        style={{
          backgroundImage: `url(${backgroundImg})`,
        }}
      />
      <div className="relative z-10 min-h-screen flex flex-col">
        <Navbar />
        <main className="flex flex-col items-center py-5 px-10">
          <div className="max-w-[960px] w-full bg-white/90 p-4 rounded-md shadow-lg">
            <ChartForm />
          </div>
        </main>
      </div>
    </div>
  );
};

export default CreateChartPage;
